module.exports = __webpack_public_path__ + "img/index-slide-12.63c8aabf.png";